
import { defineComponent } from 'vue'
import axios from 'axios'
import DevAnimated from '@/components/animated/DevAnimated.vue'
import Cards from '@/components/Cards.vue'
import DownloadApp from '@/components/DownloadApp.vue'
import Stats from '@/components/Stats.vue'
import { ElNotification } from 'element-plus'
import {
  CV,
  CVs,
  LocationUI,
  Project
} from '../types'

export default defineComponent({
  name: 'HomeView',
  components: {
    DevAnimated,
    Cards,
    DownloadApp,
    Stats,
  },
  data: () => ({
    error: null,
    projects: null as unknown as Project[],
    cv: {
      'en': {
        url: 'https://drive.google.com/file/d/1yPzS0XwN0K1xws8XCjlFpcTLcf3Fs_n4/view?usp=sharing',
        name: 'diego-perez-resume-[EN].pdf',
        lang: 'en'
      },
      'es': {
        url: 'https://drive.google.com/file/d/1vVg3WsvWl45dOQavwOxFWURB-iY9IP3G/view?usp=sharing',
        name: 'diego-perez-resume-[ES].pdf',
        lang: 'es'
      }
    } as CVs
  }),
  async beforeMount() {
    this.projects = await this.fetchProjects()
  },
  computed: {
    currentCV() {
      const currentLanguage: string = this.$i18n.locale as string || 'en'
      if (currentLanguage === 'es')
        return this.cv['es']
      else
        return this.cv['en']
    }
  },
  methods: {
    onError(error: any) {
      ElNotification({
        title: 'Error',
        message: error.message,
        duration: 5000,
        type: 'error'
      })
    },
    async fetchProjects() {
      try {
        const url = `data/projects.json`
        const result = await axios.get(url)
        const { data } = result
        return data as Project[]
      } catch (error: any) {
        this.error = error
        return null as unknown as Project[]
      }
    },
    onSelecCity(location: LocationUI) {
      this.$router.push({
        name: 'city',
        params: {
          city: location.city.toLocaleLowerCase().replaceAll(' ', '-'),
          state: location.state.toLocaleLowerCase().replaceAll(' ', '-'),
          country: location.country.toLocaleLowerCase().replaceAll(' ', '-'),
        },
        query: {
          lat: location.geometry?.coordinates[1],
          lng: location.geometry?.coordinates[0],
          preview: 'true'
        }
      })
    }
  }
})
